import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify';
import axios from 'axios';
import * as CONSTANTS from "../../../CONSTANTS";
import { FaUpload } from "react-icons/fa";

function Step8({setStep,  
            spPcdtOption, setSPPCDTOption, 
            spouseInformation, setSpouseInformation, setSpouseDietary, spouseDietary,
            spouseNeedFlight, setSpouseNeedFlight, 
            spouseClinicEvent, setSpouseClinicEvent, setSpouseAirport,
            spouseWorkingPharm, setSpouseWorkingPharm, setSpouseDesignation,
            spGoingToTradeshow, setSpGoingToTradeshow, spGoingToGalaDiner, setSpGoingToGalaDiner,
            setProcessing
        }) {

        const [dietaryOptionList, setDietaryOptionList]                 = useState([]);

        const [currentAllergy, setCurrentAllergy]           = useState('');
        const fileInputRef                                  = useRef(null);

        const [listAirports, setListAirports]                           = useState([]);

        useEffect(() => {
            listTheDietaries();
            fetchAirports();      
        },[])
    
    
        const listTheDietaries = async () => {
            try{
                setProcessing(true);
                const diet = await axios.get(CONSTANTS.API_URL +"settings/list/dietaries/v2");
        
                if(diet.data.length > 0){
                    setDietaryOptionList(diet.data);
                }
                setProcessing(false);
            }catch(errorData){
                console.log(errorData);
                setProcessing(false);
            }
        }
        
        const handleDivClick = () => {
            // This triggers the hidden file input's click event
            fileInputRef.current.click();
        };

        const handleFileChange = (e) => {
            const file = e.target.files[0];
            
            // Simple validation for 2MB
            if (file && file.size > 4 * 1024 * 1024) {
                toast.warning("File is too large! Please upload a document smaller than 4MB.");
                e.target.value = null; // Clear input
                return;
            }

            setSpouseInformation((prev) => ({
                ...prev,
                IdDocument: file,
                })
            );
        };

        const addAllergy = () => {
            if (currentAllergy.trim() !== '') {
                setSpouseInformation((prev) => ({
                    ...prev,
                    allergies: [...prev.allergies, currentAllergy.trim()],
                }));

                setCurrentAllergy(''); // Clear the small input field
            }
        };

        // 2. Remove allergy from the array
        const removeAllergy = (indexToRemove) => {
            setSpouseInformation((prev) => ({
            ...prev,
            allergies: prev.allergies.filter((_, index) => index !== indexToRemove),
            }));
        };

        const fetchAirports = async () => {
            try {
                
                const response = await axios.get(CONSTANTS.API_URL +"flights/airports/collect/list/v1");
                setListAirports(response.data);
            } catch (error) {
                console.log("Error fetching airports", error);
            }
        }
  return (
    <div className="card-step">
        <div className="card p-4 minor-yellow">
            <h5>Spouse - Profile Details </h5>
            
            <div className="mb-3 mt-3 question-box">
                   
                    
                    <div className="mb-3">
                        <label>Are they working in the pharmacy?</label>
                        <button 
                            type="button"
                            className={`btn ${spouseWorkingPharm ? 'btn-selected' : 'btn-outline-simple'} btn-full mb-3`}
                            onClick={() => setSpouseWorkingPharm(true)}
                            >
                            Yes
                        </button>
                        <button 
                            type="button"
                            className={`btn ${spouseWorkingPharm === false ? 'btn-selected' : 'btn-outline-simple'} btn-full mb-3`}
                            onClick={() => setSpouseWorkingPharm(false)}
                            >
                            No
                        </button>
                    </div>
                     {
                        spouseWorkingPharm && <div className="mb-4">
                                        <label>Designation*</label>
                                        <input type="text" className="form-control" onChange={(e) => setSpouseDesignation(e.target.value)} placeholder="Enter Role" />
                                    </div>
                    }
                   <div className="mb-3">
                        <label>Will you be attending Gala Dinner*</label>
                        
                        <button 
                            type="button"
                            className={`btn ${spGoingToGalaDiner ? 'btn-selected' : 'btn-outline-simple'} btn-full mb-3`}
                            onClick={() => setSpGoingToGalaDiner(true)}
                            >
                            Yes
                        </button>
                        <button 
                            type="button"
                            className={`btn ${spGoingToGalaDiner === false ? 'btn-selected' : 'btn-outline-simple'} btn-full mb-3`}
                            onClick={() => {
                                setSpGoingToGalaDiner(false);
                                }}
                            >
                            No
                        </button>
                    </div>
                    <div className="mb-3">
                        <label>Will you be attending the Tradeshow*</label>
                        <button 
                            type="button"
                            className={`btn ${spGoingToTradeshow ? 'btn-selected' : 'btn-outline-simple'} btn-full mb-3`}
                            onClick={() => setSpGoingToTradeshow(true)}
                            >
                            Yes
                        </button>
                        <button 
                            type="button"
                            className={`btn ${spGoingToTradeshow === false ? 'btn-selected' : 'btn-outline-simple'} btn-full mb-3`}
                            onClick={() => {
                                setSpGoingToTradeshow(false);
                            }}
                            >
                            No
                        </button>
                    </div>
                    <div className="mb-3 mt-3">
                        <label>Will you require a flight?</label>
                        <button 
                            type="button"
                            className={`btn ${spouseNeedFlight ? 'btn-selected' : 'btn-outline-simple'} btn-full mb-3`}
                            onClick={() => setSpouseNeedFlight(true)}
                            >
                            Yes
                        </button>
                        <button 
                            type="button"
                            className={`btn ${spouseNeedFlight === false ? 'btn-selected' : 'btn-outline-simple'} btn-full mb-3`}
                            onClick={() => {
                                        setSpouseNeedFlight(false);
                                        setSpouseAirport("")
                                    }
                                }
                            >
                            No
                        </button>
                    </div>
                    {
                        spouseNeedFlight && (
                            <div className="mb-3">
                                <label>Preferred Airport</label>
                                <div>
                                    Select depature airport (Outside Gauteng only)
                                </div>
                                <div className="custom-select-wrapper ">
                                    <select 
                                        className="form-control"
                                        onChange={(e) => setSpouseAirport(e.target.value)}
                                        defaultValue=""
                                        >
                                        <option value="" disabled hidden>Specify Flight</option>

                                        {
                                                listAirports.map((airport) => {
                                                    return <option key={airport._id} value={airport.title}>{airport.title}</option>
                                                })
                                        }
                                    </select>
                                </div>
                                 <div className="info-gray mt-2 mb-4">
                                    Disclaimer: The attendee is responsible for any cost related to missed flights, or changes made after booking.
                                </div>
                            </div>
                        )
                    }
                    
                    {
                        dietaryOptionList.length > 0 && (
                            <div className="mb-3">
                                <label>Dietary Requirements</label>
                                <div className="custom-select-wrapper ">
                                    <select 
                                            className="form-control"
                                            onChange={(e) => setSpouseDietary(e.target.value)}
                                            value={spouseDietary}
                                            >
                                        {
                                            dietaryOptionList.map((dietOption, index) => {
                                                return <option key={index} value={dietOption._id}>{dietOption.title}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        )
                    }

                    

                <div className="mb-3">
                    <label className="form-label">Allergies</label>
                    <div className="input-group mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="e.g. Peanuts"
                            value={currentAllergy}
                            onChange={(e) => setCurrentAllergy(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addAllergy())}
                        />
                        <button 
                            className="btn btn-outline-secondary" 
                            type="button" 
                            onClick={addAllergy}>
                            Add
                        </button>
                    </div>

                    {/* Render the list of added allergies */}
                    <div className="d-flex flex-wrap gap-2">
                            {spouseInformation.allergies.map((allergy, index) => (
                            <span key={index} className="badge bg-info text-dark p-2 d-flex align-items-center">
                                {allergy}
                                <button
                                    type="button"
                                    className="btn-close btn-close-white ms-2"
                                    style={{ fontSize: '0.6rem' }}
                                    onClick={() => removeAllergy(index)}
                                    ></button>
                            </span>
                            ))}
                        </div>
                </div>

                <div className="mb-3">
                   <div 
                        onClick={handleDivClick}
                        className="input-dialogue"
                        style={{ cursor: 'pointer' }}>
                        <div className="upload-icon-hip">
                            <FaUpload />
                        </div>
                        <div className="d-flex">
                            <div className="text-center up-text-1">
                                Click to upload ID document
                            </div>
                            <div className="text-center  up-text-2">
                                PDF, JPG, JPEG, or PNG (Max 4MB)
                            </div>
                        </div>
                        <input 
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }} // Hides the input from view
                            onChange={handleFileChange}
                            />
                            {
                                spouseInformation.IdDocument && (
                                <small className="text-success d-block mt-2">
                                    File selected: {spouseInformation.IdDocument.name}
                                </small>
                               )
                            }
                   </div>
                </div>
            </div>
            {
                spouseInformation.IdDocument && (
                    <button
                        className="btn btn-main btn-full" 
                        onClick={() => setStep(prev => prev + 1)}>
                            Continue
                    </button>
                )
            }
        </div>
    </div>
  )
}

export default Step8